import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Experience } from '../../API';
import { EXPERIENCE_HUMAN_NAMES } from '../../models/engineer';

export default function ExperienceCardContent({ experience }: { experience: Experience }) {
  return (
    <CardContent>
      <Typography variant="h5" align="center">
        Experience:
        {' '}
        {EXPERIENCE_HUMAN_NAMES[experience] || 'Unknown'}
      </Typography>
    </CardContent>
  );
}
